import { useState } from "react";
import logingql from "gql/auth/login.gql";
import profilegql from "gql/auth/profile.gql";
import logoutgql from "gql/auth/logout.gql";
import { useApolloClient } from "@apollo/client";
import { useAppContext } from "contexts/AppContext";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

const useAuth = () => {
  // contexts
  const { appState, setAppState } = useAppContext();

  // states
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  // hooks
  const apollo = useApolloClient();

  // functions
  const authenticate = (userData) => {
    setData(userData);
    Sentry.setUser({
      id: userData.id,
      email: userData.email,
      entity: userData.entity?.name,
      role: userData.role?.name,
    });
    setAppState({
      key: "auth",
      value: {
        isAuthenticated: true,
        user: userData,
      },
    });
  };

  const revokeAuthentication = () => {
    setAppState({
      key: "auth",
      value: {
        isAuthenticated: false,
        user: null,
      },
    });
  };

  const login = (email, password) => {
    setLoading(true);
    apollo
      .mutate({ mutation: logingql, variables: { email, password } })
      .then((data) => {
        authenticate(data.data.tokenAuth.user);
      })
      .catch((err) => {
        setError(err);
        toast.error(err.message);
      })
      .finally((f) => setLoading(false));
  };

  const logout = () => {
    setLoading(true);
    apollo
      .mutate({ mutation: logoutgql })
      .then((data) => {
        setData(data);
        revokeAuthentication();
      })
      .catch((err) => {
        setError(err);
        toast.error(err);
      })
      .finally((f) => setLoading(false));
  };

  const isAuthenticated = () => {
    setLoading(true);
    if (appState.settings.internet.online) {
      apollo
        .query({ query: profilegql })
        .then((data) => {
          authenticate(data.data.myProfile);
        })
        .catch((err) => {
          revokeAuthentication();
        })
        .finally((f) => setLoading(false));
    } else {
      setLoading(false);
    }
  };

  return { loading, data, error, login, logout, isAuthenticated };
};

export default useAuth;
